import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { TextBox, formatDate, formatTime } from "../../Components/InputElements";
import { decodeData } from "../../Constants/constants";
class AttendanceMuster extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {

      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      location_id: "",
      department_id: "",
      Department: [],
      Location: [],
      Department: [],
      Location: [],
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      selectedEmployeeId: null,
      selectedRows: [],
      dates: [],
      months: [{ "label": "Jan - 2024", "value": 1},
      { "label": "Feb - 2024", "value": 2},
      { "label": "Mar - 2024", "value": 3},
      { "label": "Apr - 2024", "value": 4},
      { "label": "May - 2024", "value": 5},
      { "label": "Jun - 2024", "value": 6},
      { "label": "Jul - 2024", "value": 7},
      { "label": "Aug - 2024", "value": 8},
      { "label": "Sep - 2024", "value": 9},
      { "label": "Oct - 2024", "value": 10},
      { "label": "Nov - 2024", "value": 11},
      { "label": "Dec - 2024", "value": 12}],
      decodedData: [],

    };
    
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetDepartmentMasters();
      this.GetLocationMasters();

    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Attendance/GetEmployeeAttendance?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      console.log(`data`, data);
      if (success === true) {
        this.setState(
          {
            employee_name: data[0].employee_name,
            employee_mobile_number: data[0].employee_mobile_number,
            employee_email_address: data[0].employee_email_address,
            employee_gender: data[0].employee_gender,
            employee_joining_date: data[0].employee_joining_date,
            designation_id: data[0].designation_id,
            department_id: data[0].department_id,
            grade_id: data[0].grade_id,
            location_id: data[0].location_id,
            employee_address: data[0].employee_address,
            reporting_manager_id: data[0].reporting_manager_id,
            blood_Group: data[0].blood_group,
            From_date: data[0].employee_from_date,
            To_date: data[0].employee_from_to,
            Date_of_birth: data[0].date_of_birth,
            Title: data[0].employee_title,
            company_employee_category_id: data[0].employee_category,
            company_employee_type_id: data[0].employee_type,
            permanent_Address: data[0].employee_permanent_address,
            pinCode: data[0].pin_code,
            enter_State: data[0].employee_state,
          }
        )
      }
    });
  }

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };



  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    var params = {
      limit: this.state.limit,
      page: this.state.page??1,
      keyword: this.state.keyword,
      from_date: this.state.from_date,
      to_date: this.state.to_date,
      department_id: this.state.department_id,
      location_id: this.state.location_id,
      dates: []
    };
    
    axios
      .get(`${apiURL}Attendance/GetAttendanceMuster`, {
        params: params,
        headers,
      })
      .then((response) => {
        var data = response.data;
        console.log("data", data);
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page?data.page:1,
            total_records: data.total_records?data.total_records:0,
            total_pages: data.total_pages?data.total_pages:0,
            loadingList: false,
          }, (prevState) => {
           
            this.renderMusterHeadsDays();
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, (prevState) => {
      this.renderMusterHeadsDays();
    });
  };
  showAll = () =>{
    this.setState({limit: this.state.total_records}, () => {
      this.GetList();
    })
  }
  handleClearAll = () => {
    this.setState({
      employee_id: 0,
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
    }
      , () => {
        this.GetList();
      });
  };

  handleSelectStatus = (selectedOption) => {

    this.setState({ selectOption: selectedOption.value, });
  };

  handleDepartmentChange = (selectedOption) => {
    this.setState({
      department_id: selectedOption.value,
    });
  };

  handleLocationChange = (selectedOption) => {
    this.setState({
      location_id: selectedOption.value,
    });
  };

  handleSelectType = (selectedOption) => {
    this.setState({ filter_leave_type_id: selectedOption.value, });
  };

  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };
   getDuration = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    // Calculate the difference in milliseconds
    const durationMs = end - start;

    // Convert milliseconds to human-readable format
    const milliseconds = durationMs % 1000;
    let seconds = Math.floor((durationMs / 1000) % 60);
    let minutes = Math.floor((durationMs / (1000 * 60)) % 60);
    let hours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
    const days = Math.floor(durationMs / (1000 * 60 * 60 * 24));

    // Add leading zeros if necessary
    seconds = seconds < 10 ? "0" + seconds : seconds;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    hours = hours < 10 ? "0" + hours : hours;

    return hours;
}
  renderMusterHeadsDays = () => {
    const dates = [];
    if(this.state.from_date && this.state.to_date){
      const from_date = new Date(this.state.from_date);
      const to_date = new Date( this.state.to_date); 
      
      let current_date = from_date;

      while (current_date <= to_date) { 
        
        var day = new Date(current_date).getDate();
        var month = new Date(current_date).getMonth() + 1;
        var year = new Date(current_date).getFullYear();
          dates.push({date: `${year}-${month}-${day}`, present: '-'});
          current_date.setDate(current_date.getDate() + 1);
      }
      
      this.setState({dates:dates});
    }else{
      this.setState({dates:dates});
    }
    this.setState({dates:dates});
    
  }
  renderMusterPresenti = (presents) => {
     for(var i = 0; i < this.state.dates.length; i++){
      // for(var i = 0; i < presentsDates.length; i++){
     }
  }
  getPresenti = (day, presents) => {
    if(presents) {
      
        var presentsDates = presents.split(',');
        for(var i = 0; i < presentsDates.length; i++) {
            if(day.date === presentsDates[i]) {
              console.log(day, presentsDates[i]);
                return "P";
            }else {
              return "A";
          }
        }
    } else {
        return "A";
    }
    return "x";
}
  // renderMusterPresenti = (presents) => {
  //   const dates = [];
  //   try{
  //     presents.split(',');
  //   }catch(er){
  //     console.log("er", er)
  //     return dates;
  //   }
  //   if(this.state.from_date && this.state.to_date){
     
  //     let current_date = this.state.from_date;

  //     while (current_date <= to_date) { 
  //       var presentsDates = presents.split(',');
  //       if(presentsDates.length === 0){
  //          dates.push("A"); 
  //       }
  //       for(var i = 0; i < presentsDates.length; i++){
  //         if(current_date === presentsDates[i]){
  //            dates.push("P");
  //         }else {
  //            dates.push("A");
  //         }
  //       }
  //     }
  //     console.log("datesx1", dates)
  //     return dates;
  //   }else{
  //     console.log("datesx2", dates)
  //     return dates;
  //   }
    
    
  // }
  handleMonthChange = (e) => {
    var year = new Date().getFullYear();;
    var inputDate = `${year}-${e.value}-01`
    const dateObj = new Date(inputDate);
    const lastDay = new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0);
    const formattedLastDay = lastDay.toISOString().slice(0, 10);
    
    this.setState({loadingList: true ,from_date: inputDate, to_date: formattedLastDay}, (prevState) => {
      console.log(this.state.from_date, this.state.to_date )
      
      this.GetList();
      
    })
  }

  render() {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Attendance Report`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Enter keyword</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                        </div>
                      </div>
                      <div className='col-md-2'>
                        <label htmlFor="Location" className="form-label" > Select Month </label>
                        <Select options={this.state.months} onChange={(e) => this.handleMonthChange(e)}/>
                      </div>
                      
                      <div className="col-md-2 ">

                        <label htmlFor="Department" className="form-label" > Department </label>
                        <Select value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null} options={this.state.Department} onChange={this.handleDepartmentChange} hint={`Select Department`} />
                      </div>

                      <div className="col-md-2 ">
                            <label htmlFor="Location" className="form-label" > Location </label>
                            <Select value={this.state.location_id ? this.state.Location.find(option => option.value === this.state.location_id) : null} options={this.state.Location} onChange={this.handleLocationChange} hint={`Select Location`} />
                      </div>
                          <div className='col-md-1' >
                            <div>
                              <label>Apply Filter</label>
                            </div>
                            <button type="button" onClick={this.handleInputSearch} className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                              <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                              Filter
                            </button>
                          </div>
                          <div className='col-md-1'>
                            <div> <label>Show All</label> </div>
                            <button type="button" className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`} onClick={this.showAll} >
                              <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Show All</button>
                          </div>
                    </div>

                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-hover`} style={{fontSize: '8px'}}>
                      <thead className="table-light">
                        <tr>

                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          
                          <th>Department</th>
                          <th>Location</th>
                          <th>Shift Title</th>
                          {
                            this.state.dates.map((day) => {
                              var dayHead = new Date(day.date).getDate();
                              return <th  >{dayHead}</th>
                            })
                          }
                          <th>Payable Days</th>
                          <th>Present</th>
                          <th>Absent</th>
                          <th>Week Off</th>
                          <th>Holidays</th>
                          <th>Leaves</th>
                        </tr>
                      </thead>
                      <tbody>
                      
                        {Array.isArray(this.state.rows) && this.state.rows.length > 0 ? (
                          this.state.rows.map((row) => (
                            <tr key={row.employee_id}>
                              <td>{row.employee_code}</td>
                              <td>
                                <NavLink to={`/AttendenceDashboard/${row.employee_id}`}>
                                  {row.employee_name}
                                </NavLink>
                              </td>
                              <td>{row.department_title}</td>
                              <td>{row.location_title}</td>
                              <td>{row.company_location_shift_name}</td>
                              
                              
                              { 
                              
                              this.state.dates.map((day) => {
                                  const presenti = this.getPresenti(day, row.present_days);
                                  return <th>{(presenti)}</th>
                              })}
                              <td>{row.payable_days}</td>
                              <td>{ row.present_days?(row.present_days.split(',').length): 0 }</td>
                              <td>{ this.state.dates.length - (row.present_days?(row.present_days.split(',').length): 0)  }</td>
                              <td>{row.weekends_count}</td>
                              <td>{row.total_holidays}</td>
                              <td>{row.leaves_count}</td>
                            </tr>
                          ))
                        ) : (
                          <div>No rows to display</div>
                        )}


                      </tbody>
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={18}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AttendanceMuster);
